import QuestionModel from "../QuestionModel";
import QuestionValue from "../QuestionValue";
import QuestionValueMeasurementLabel from "../QuestionValueMeasurementLabel";
import QuestionValueUnitConversion from "../QuestionValueUnitConversion";
import QuestionModule from "./QuestionModule";
import QuestionValueSortConversion from "../QuestionValueSortConversion";
import moment from "moment";
import QuestionValueTime from "../QuestionValueTime";
import QuestionValueTime12 from "../QuestionValueTime12";

export default class QuestionModuleMeasurement extends QuestionModule {
    constructor() {
        super();
    }

    create(data) {
        const question = super.create(data);

        switch (data.type) {
            case QuestionModel.TYPE_PERIMETER: {
                this._perimeter(data, question);
                break;
            }
            case QuestionModel.TYPE_AREA_TRIANGLE: {
                this._visualGeometry(data, question);
                break;
            }
            case QuestionModel.TYPE_AREA_PARALLELOGRAM: {
                this._visualGeometry(data, question);
                break;
            }
            case QuestionModel.TYPE_AREA_CIRCLE: {
                this._visualGeometry(data, question);
                break;
            }
            case QuestionModel.TYPE_DIAMETER: {
                this._visualGeometry(data, question);
                break;
            }
            case QuestionModel.TYPE_RADIUS: {
                this._visualGeometry(data, question);
                break;
            }
            case QuestionModel.TYPE_COVERSION_X_IN_Y: {
                this._conversionXinY(data, question);
                break;
            }
            case QuestionModel.TYPE_COVERSION_SUBTRACTION: {
                this._conversionAddSub(data, question);
                break;
            }
            case QuestionModel.TYPE_COVERSION_ADDITION: {
                this._conversionAddSub(data, question);
                break;
            }
            case QuestionModel.TYPE_COVERSION_PERCENT_OF_X: {
                this._conversionPercentageOfX(data, question);
                break;
            }
            case QuestionModel.TYPE_COVERSION_MULTIPLICATION: {
                this._conversionMultiplcation(data, question);
                break;
            }
            case QuestionModel.TYPE_COVERSION_EQUIVALENT: {
                this._conversionEquivalent(data, question);
                break;
            }
            case QuestionModel.TYPE_COVERSION_SORT: {
                this._conversionSort(data, question);
                break;
            }
            case QuestionModel.TYPE_TIME_DIFFERENCE: {
                if (data.difficulty < 2)
                    this._time12(data, question);
                else
                    this._time(data, question);
                break;
            }
            case QuestionModel.TYPE_TIME_CONVERSION: {
                this._time(data, question);
                break;
            }
            case QuestionModel.TYPE_LIQUID_MEASUREMENT: {
                this._liquidMeasurment(data, question);
                break;
            }
        }
        question.xp = data.xp;

        return question;
    }

    _conversionAddSub(data, question) {
        let round = (value, decimals) => {
            return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
        };
        let selected = P3.utils.selectRandom(data.variations);
        let values = this._generateValues(selected.range, data.values - 1);
        values.sort();

        let result;
        for (let i = values.length - 1; i >= 0; i--) {
            let n = values[i];
            if (i === values.length - 1) {
                question.values.push(new QuestionValueUnitConversion(n, ''));
                result = n;
            }
            else {
                switch (data.type) {
                    case QuestionModel.TYPE_COVERSION_SUBTRACTION: {
                        result -= n;
                        //convert value
                        question.values.push(new QuestionValueUnitConversion(n * selected.conversion, selected.units[0].short));
                        //remainder
                        question.values.push(new QuestionValueUnitConversion(Math.abs(round(result - n, 2)), selected.units[1].short));
                        break;
                    }
                    case QuestionModel.TYPE_COVERSION_ADDITION: {
                        result += n;
                        //convert value
                        question.values.push(new QuestionValueUnitConversion(n * selected.conversion, ''));
                        break;
                    }
                }
            }
        }
        question.conversion = selected.conversion;
        //question.values.push(new QuestionValueUnitConversion(Math.round(result * 100) / 100, selected.units[1].short));
        question.units = selected.units;
        result = parseFloat(round(result, 2));//added fix for unexpected long floats - ob
        question.values.push(new QuestionValueUnitConversion(result, selected.units[1].short));
        question.part = typeof data.parts === "number" ? data.parts : P3.utils.selectRandom(P3.utils.objectToArray(data.parts));
        question.options = this.generateOptions(question, 5);
        question.item = data.item;
        question.item = selected.item || null;
        question.unitType = selected.unit_type || null;
    }

    _conversionMultiplcation(data, question) {
        let selected = P3.utils.selectRandom(data.variations);

        let height = P3.math.random(selected.range.min, selected.range.max);
        let heightRounded = Math.round(height * 10) / 10;
        let multiple = P3.math.randomInt(data.range.min, data.range.max);

        question.values.push(new QuestionValueUnitConversion(heightRounded, selected.units[selected.units.length - 1].short));
        question.values.push(new QuestionValue(multiple));

        let result = heightRounded * multiple;
        let conversionFactor = selected.units[P3.math.randomInt(0, selected.units.length - 2)];
        let convertedResult = result * conversionFactor.conversion;

        question.values.push(new QuestionValueUnitConversion(Math.round(convertedResult * 10) / 10, conversionFactor.short));
        question.units = selected.units;
        question.part = 2;
        question.options = this.generateOptions(question, 5);
        question.item = selected.item || null;
        question.unitType = selected.unit_type || null;
    }

    _conversionEquivalent(data, question) {
        let selected = P3.utils.selectRandom(data.variations);

        let dist = P3.math.random(selected.range.min, selected.range.max);
        let distRounded = Math.round(dist * 10) / 10;

        question.values.push(new QuestionValueUnitConversion(distRounded, selected.units[selected.units.length - 1].short));

        //create a couple of correct answers
        let tempUnits = P3.utils.copyObject(selected.units, true);
        tempUnits.splice(tempUnits.length - 1, 1);
        for (let i = 0; i < 2; i++) {
            let conversion = tempUnits[P3.math.randomInt(0, tempUnits.length - 1)];
            let convertedResult = distRounded * conversion.conversion;
            question.values.push(new QuestionValueUnitConversion(Math.round(convertedResult * 100) / 100, conversion.short));
            tempUnits.splice(tempUnits.indexOf(conversion), 1);
        }

        question.units = selected.units;
        question.part = [1, 2];
        question.options = this.generateOptions(question, 3);
        for (const number in question.part) {
            question.options.push(question.values[question.part[number]]);
        }
        P3.utils.shuffleArray(question.options);
    }

    _conversionPercentageOfX(data, question) {
        let selected = P3.utils.selectRandom(data.variations);

        let values = this._generateValues(selected.range, data.values - 1);
        let t = [];
        values.sort();
        values.forEach((n) => {
            t.push(Math.ceil(n / 10) * 10);
            question.values.unshift(new QuestionValue(Math.ceil(n / 10) * 10))
        });

        let result = t[0] / (t[1] / selected.conversion);
        question.values.push(new QuestionValueUnitConversion(Math.round(result * 100) / 100, selected.units[0].short));

        question.conversion = selected.conversion;
        question.part = data.parts;
        question.units = selected.units;
        question.options = this.generateOptions(question, 5);
        question.item = selected.item;
    }

    _conversionSort(data, question) {
        const selected = P3.utils.selectRandom(data.variations);
        question.ascending = P3.math.randomBool();

        const values = [];
        let attempts = 100;

        while (values.length < data.values && attempts-- > 0)
        {
            const dist = P3.math.random(selected.range.min, selected.range.max);
            const distRounded = Math.round(dist * 10) / 10;

            if (values.indexOf(distRounded) === -1)
            {
                const conversion = P3.utils.selectRandom(selected.units);
                let convertedResult = distRounded * conversion.conversion;
                question.values.push(new QuestionValueSortConversion(Math.round(convertedResult * 10) / 10, conversion.short, conversion.conversion));

                values.push(distRounded);
            }
        }

        question.values.sort((a, b) =>
        {
            return question.ascending ? a.value - b.value : b.value - a.value;
        });

        question.units = selected.units;
        question.item = selected.item || null;
        question.unitType = selected.unit_type || null;

        /*
        let selected = P3.utils.selectRandom(data.variations);
        question.ascending = P3.math.randomBool();

        //create random values
        let tempUnits = P3.utils.copyObject(selected.units, true);

        for (let i = 0; i < data.values; i++) {
            let dist = P3.math.random(selected.range.min, selected.range.max);
            let distRounded = Math.round(dist * 10) / 10;
            let conversion = tempUnits[P3.math.randomInt(0, tempUnits.length - 1)];
            let convertedResult = distRounded * conversion.conversion;
            question.values.push(new QuestionValueSortConversion(Math.round(convertedResult * 10) / 10, conversion.short, conversion.conversion));
        }

        question.values.sort((a, b) => {
            return question.ascending ? a.value - b.value : b.value - a.value;
        });

        question.units = selected.units;
        question.item = selected.item || null;
        question.unitType = selected.unit_type || null;
        */
    }

    _conversionXinY(data, question) {
        let randOption = P3.utils.selectRandom(P3.utils.objectToArray(data.options));
        let reversed = Math.random() < 0.5;
        question.part = reversed ? 0 : 1;

        let values = this._generateValues(randOption.range, data.values - 1);
        values.forEach((n) => {
            question.values.push(new QuestionValueUnitConversion(n, randOption.units[1].short));
        });
        question.values.push(new QuestionValueUnitConversion(Math.round(((question.values[0].value * randOption.conversion) * 100) / 100), randOption.units[0].short));
        question.units = randOption.units;
        question.reversed = reversed;
        question.options = this.generateOptions(question, 5);
    }

    _liquidMeasurment(data, question) {
        let selected = P3.utils.selectRandom(data.variations);
        //if difficulty === 0 generate an answer that is a multiple of 5
        //else generate an aswer that is a multiple of 1

        let r, step, substeps;
        let answers = [];
        if (data.difficulty === 0) {
            r = P3.utils.selectRandom([25, 50, 75]);
            answers = [];

            for (let i = 1; i < 10; i++) {
                let s = r / 10;

                if (i * s % 5 === 0)
                    answers.push(i);
            }
            step = P3.utils.selectRandom(answers);
            substeps = 10;
        }

        if (data.difficulty === 1) {
            r = P3.utils.selectRandom([20, 40, 60, 80, 100]);
            answers = [];
            for (let i = 1; i < 10; i++) {
                let s = r / 10;

                if (i * s % 2 === 0)
                    answers.push(i);
            }
            step = P3.utils.selectRandom(answers);
            substeps = 10;
        }

        if (data.difficulty === 2) {
            r = P3.utils.selectRandom([20, 40, 60, 80, 100]);
            answers = [];
            for (let i = 1; i < 20; i++) {
                let s = r / 20;

                if (i * s % 2 === 0)
                    answers.push(i);
            }
            step = P3.utils.selectRandom(answers);
            substeps = 20;
        }

        question.steps = 10;
        question.substeps = substeps;
        question.selectedStep = step;
        question.selectedSubStep = step;
        question.values.push(new QuestionValueUnitConversion(r, selected.units[1].short));
        question.values.push(new QuestionValueUnitConversion(0, selected.units[0].short));
        question.values.push(new QuestionValueUnitConversion((r / substeps) * step, selected.units[1].short));

        question.item = selected.item;
        question.part = 2;
        question.units = selected.units;
        question.difficulty = data.difficulty;


        // let round = (value, decimals)=> {
        // 	return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
        // };
        //
        // let values = this._generateValues(selected.range, 1);
        // if(data.difficulty === 0)
        // 	values[0] = Math.ceil(values[0] / 5) * 5; //round to nearest 5
        //
        // let beakerSteps = 10;
        // let subSteps = 10;
        // let max = values[0];
        // let selectedStep = P3.math.randomInt(1, beakerSteps - 1);
        // let indicator = round((((max / beakerSteps) * selectedStep) * selected.conversion), 1);
        // let selectedSubStep = P3.math.randomInt(1, subSteps);
        // let answer = Math.round(((max / subSteps) * selectedSubStep )* 100) / 100;
        //
        // question.steps = beakerSteps;
        // question.substeps = subSteps;
        // question.selectedStep = selectedStep;
        // question.selectedSubStep = selectedSubStep;
        // question.fillPercentage = ((indicator / selected.conversion) / 100) * max;
        // question.values.push(new QuestionValueUnitConversion(max, selected.units[1].short));
        // question.values.push(new QuestionValueUnitConversion(indicator, selected.units[0].short));
        // question.values.push(new QuestionValueUnitConversion(answer, selected.units[1].short));
        //
        // question.item = selected.item;
        // question.part = 2;
        // question.units = selected.units;

        question.options = this.generateOptions(question, 5);
    }

    _time(data, question) {
        let parseTime = (s) => {
            var c = s.split(':');
            return parseInt(c[0]) * 60 + parseInt(c[1]);
        };
        let generateTime = (previousTime) => {
            let clock24h;
            let currentMinutes = P3.math.randomInt(0, 54);
            if (previousTime) {
                let t = previousTime.split(':');
                let k = 1000;
                switch (data.difficulty) {
                    case 2:
                        if (currentMinutes > parseInt(t[1])) {
                            do {
                                clock24h = P3.math.randomInt(parseInt(t[0]), Math.max(1, parseInt(t[0]) - 12));
                            } while (clock24h === parseInt(t[0]) && currentMinutes === parseInt(t[1]) && k-- > 0);
                            clock24h = P3.math.randomInt(parseInt(t[0]), Math.max(1, parseInt(t[0]) - 12));
                        } else
                            do {
                                clock24h = P3.math.randomInt(parseInt(t[0]), Math.min(23, parseInt(t[0]) + 12));
                            } while (clock24h === parseInt(t[0]) && currentMinutes === parseInt(t[1]) && k-- > 0);
                        clock24h = P3.math.randomInt(parseInt(t[0]), Math.min(23, parseInt(t[0]) + 12));
                        break;
                    //clock24h = P3.math.randomInt(Math.max(1, parseInt(t[0]) - 6), Math.min(23, parseInt(t[0]) + 6));
                    //break;
                    case 3:
                        if (currentMinutes > parseInt(t[1])) {
                            do {
                                clock24h = P3.math.randomInt(parseInt(t[0]), Math.max(1, parseInt(t[0]) - 23));
                            } while (clock24h === parseInt(t[0]) && currentMinutes === parseInt(t[1]) && k-- > 0);
                            clock24h = P3.math.randomInt(parseInt(t[0]), Math.max(1, parseInt(t[0]) - 23));
                        } else
                            do {
                                clock24h = P3.math.randomInt(parseInt(t[0]), Math.min(23, parseInt(t[0]) + 23));
                            } while (clock24h === parseInt(t[0]) && currentMinutes === parseInt(t[1]) && k-- > 0);
                        clock24h = P3.math.randomInt(parseInt(t[0]), Math.min(23, parseInt(t[0]) + 23));
                        break;
                    //clock24h = P3.math.randomInt(Math.max(1, parseInt(t[0]) - 12), Math.min(23, parseInt(t[0]) + 12));
                    //break;
                }
            } else {
                clock24h = P3.math.randomInt(1, 23);
                //currentMinutes = P3.math.randomInt(0, 54);
            }

            currentMinutes = (currentMinutes < 10 ? "0" : "") + currentMinutes;
            clock24h = (clock24h < 10 ? "0" : "") + clock24h;

            return clock24h + ":" + currentMinutes
        };

        let hours = 0;
        let minutes = 0;

        // let times = [];
        // //generate 24 hour time between 01:00 - 23:59
        // let t1 = generateTime();
        //
        // //generate 24 hour time +- range of t1
        // let t2 = generateTime(t1);
        //
        // times.push(moment(t1, 'HH:mm'));
        // times.push(moment(t2, 'HH:mm'));
        //
        // //sort array to make sure smaller number subtracts from larger
        // times.sort((a,b)=>{
        // 	let t1 = parseTime(a._i);
        // 	let t2 = parseTime(b._i);
        // 	return t1 - t2;
        // });
        //
        // //get difference between times
        // let diff = (times[1].diff(times[0], 'minutes', true));
        // let hours = Math.floor(diff / 60);
        // let minutes = diff % 60;

        let j = 1000;
        let times = [];
        while (hours === 0 && minutes === 0 && j-- > 0) {
            times = [];
            //generate 24 hour time between 01:00 - 23:59
            let t1 = generateTime();

            //generate 24 hour time +- range of t1
            let t2 = generateTime(t1);

            times.push(moment(t1, 'HH:mm'));
            times.push(moment(t2, 'HH:mm'));

            //sort array to make sure smaller number subtracts from larger
            times.sort((a, b) => {
                let t1 = parseTime(a._i);
                let t2 = parseTime(b._i);
                return t1 - t2;
            });
            let diff = (times[1].diff(times[0], 'minutes', true));
            hours = Math.floor(diff / 60);
            minutes = diff % 60;
        }

        //create values for question
        for (const time in times) {
            let c = times[time]._i.split(':');
            let t = [parseInt(c[0]), parseInt(c[1])];
            question.values.push(new QuestionValueTime(t));
        }

        //value of difference
        question.values.push(new QuestionValueTime([hours, minutes]));

        if (data.view === 'verbal_time') {
            question.part = 2;
            question.timeType = 'string';
        }
        if (data.type === 'time_conversion')
            question.part = 0;
        else {
            question.part = P3.utils.selectRandom([1, 2]);
        }

        //generate some options
        question.options = [question.answer];

        let k = 1000;
        while (question.options.length < 5 && k-- > 0) {
            const value = (() => {
                let hour;
                const minMin = 1;
                const maxMin = 55;
                let minutes = P3.math.randomInt(minMin, maxMin);
                hour = question.answer.value[0];
                return [hour, minutes];
            })();
            question.options.every(x => (x.value[0] !== value[0] || x.value[1] !== value[1])) && question.options.push(new QuestionValueTime(value));
        }
        P3.utils.shuffleArray(question.options);

        question.difficulty = data.difficulty;
    }

    _time12(data, question) {
        let parseTime = (s) => {
            var c = s.split(':');
            return parseInt(c[0]) * 60 + parseInt(c[1]);
        };
        let generateTime = (previousTime) => {
            let clock24h;
            let currentMinutes = P3.math.randomInt(0, 54);
            if (previousTime) {
                let t = previousTime.split(':');
                switch (data.difficulty) {
                    case 0:
                        if (currentMinutes > parseInt(t[1])) {
                            // do {
                            // 	clock24h = P3.math.randomInt(parseInt(t[0]), Math.max(1, parseInt(t[0]) - 1));
                            // }while(clock24h === parseInt(t[0]) && currentMinutes === parseInt(t[1]) && k-- > 0);
                            clock24h = Math.max(1, parseInt(t[0]) - 1);
                        } else
                        // do {
                        // 	clock24h = P3.math.randomInt(parseInt(t[0]), Math.min(23, parseInt(t[0]) + 1));
                        // }while(clock24h === parseInt(t[0]) && currentMinutes === parseInt(t[1]) && k-- > 0);
                            clock24h = Math.min(23, parseInt(t[0]));
                        break;
                    case 1:
                        if (currentMinutes > parseInt(t[1])) {
                            // do {
                            // 	clock24h = P3.math.randomInt(parseInt(t[0]), Math.max(1, parseInt(t[0]) - 2));
                            // }while(clock24h === parseInt(t[0]) && currentMinutes === parseInt(t[1]) && k-- > 0);
                            clock24h = P3.math.randomInt(parseInt(t[0]), Math.max(1, parseInt(t[0]) - 2));
                        } else
                        // do {
                        // 	clock24h = P3.math.randomInt(parseInt(t[0]), Math.max(23, parseInt(t[0]) + 2));
                        // }while(clock24h === parseInt(t[0]) && currentMinutes === parseInt(t[1]) && k-- > 0);
                            clock24h = P3.math.randomInt(parseInt(t[0]), Math.min(23, parseInt(t[0]) + 2));
                        break;
                }
            } else {
                clock24h = P3.math.randomInt(1, 23);
                //currentMinutes = P3.math.randomInt(0, 54);
            }

            if (data.difficulty === 0 || data.difficulty === 1) currentMinutes = Math.ceil(currentMinutes / 5) * 5;

            currentMinutes = (currentMinutes < 10 ? "0" : "") + currentMinutes;
            clock24h = (clock24h < 10 ? "0" : "") + clock24h;

            return clock24h + ":" + currentMinutes
        };


        let hours = 0;
        let minutes = 0;

        // let times = [];
        // //generate 24 hour time between 01:00 - 23:59
        // let t1 = generateTime();
        //
        // //generate 24 hour time +- range of t1
        // let t2 = generateTime(t1);
        //
        // times.push(moment(t1, 'HH:mm'));
        // times.push(moment(t2, 'HH:mm'));
        //
        // //sort array to make sure smaller number subtracts from larger
        // times.sort((a,b)=>{
        // 	let t1 = parseTime(a._i);
        // 	let t2 = parseTime(b._i);
        // 	return t1 - t2;
        // });
        //
        // //get difference between times
        // let diff = (times[1].diff(times[0], 'minutes', true));
        // let hours = Math.floor(diff / 60);
        // let minutes = diff % 60;

        let j = 1000;
        let times = [];
        while (hours === 0 && minutes === 0 && j-- > 0) {
            times = [];
            //generate 24 hour time between 01:00 - 23:59
            let t1 = generateTime();

            //generate 24 hour time +- range of t1
            let t2 = generateTime(t1);

            times.push(moment(t1, 'HH:mm'));
            times.push(moment(t2, 'HH:mm'));

            //sort array to make sure smaller number subtracts from larger
            times.sort((a, b) => {
                let t1 = parseTime(a._i);
                let t2 = parseTime(b._i);
                return t1 - t2;
            });
            let diff = (times[1].diff(times[0], 'minutes', true));
            hours = Math.floor(diff / 60);
            minutes = diff % 60;
        }

        //create values for question
        for (const time in times) {
            let c = times[time]._i.split(':');
            let t = [parseInt(c[0]), parseInt(c[1])];
            question.values.push(new QuestionValueTime12(t));
        }

        //value of difference
        question.values.push(new QuestionValueTime12([hours, minutes]));

        if (data.view === 'verbal_time') {
            question.part = 2;
            question.timeType = 'string';
        }
        if (data.type === 'time_conversion')
            question.part = 0;
        else {
            question.part = P3.utils.selectRandom([1, 2]);
        }

        //generate some options
        question.options = [question.answer];

        let k = 1000;
        while (question.options.length < 5 && k-- > 0) {
            const value = (() => {
                let hour;
                const minMin = (data.difficulty === 0 || data.difficulty === 1) ? 5 : 1;
                const maxMin = 55;
                let minutes = P3.math.randomInt(minMin, maxMin);
                minutes = (data.difficulty === 0 || data.difficulty === 1) ? Math.ceil(parseInt(minutes) / 5) * 5 : minutes;
                hour = question.answer.value[0];
                // switch (data.difficulty) {
                // 	case 0:
                // 		hour = question.answer.value[0];
                // 		break;
                // 	case 1:
                // 		hour = P3.math.randomInt(question.answer.value[0], Math.min(23, question.answer.value[0] + 2));
                // 		break;
                // 	case 2:
                // 		hour = P3.math.randomInt(question.answer.value[0], Math.min(23, question.answer.value[0] + 12));
                // 		// hour = P3.math.randomInt(
                // 		// 	Math.max(0, question.answer.value[0] - 6), Math.min(23, question.answer.value[0] + 6)
                // 		// );
                // 		break;
                // 	case 3:
                // 		hour = P3.math.randomInt(
                // 			Math.max(0, question.answer.value[0] - 12), Math.min(23, question.answer.value[0] + 12)
                // 		);
                // 		break;
                // }
                return [hour, minutes];
            })();
            question.options.every(x => (x.value[0] !== value[0] || x.value[1] !== value[1])) && question.options.push(new QuestionValueTime12(value));
        }
        P3.utils.shuffleArray(question.options);
    }

    _visualGeometry(data, question) {

        let unit = P3.utils.selectRandom(data.units);
        let randomData = P3.utils.selectRandom(P3.utils.objectToArray(data.range));
        question.values = this._generateMeasurementLabel(randomData, unit);
        question.part = data.parts;

        let r;
        switch (data.type) {
            case QuestionModel.TYPE_AREA_TRIANGLE: {
                r = (question.values[0].value * question.values[1].value) / 2;
                break;
            }
            case QuestionModel.TYPE_AREA_PARALLELOGRAM: {
                r = (question.values[0].value * question.values[1].value);
                break;
            }
            case QuestionModel.TYPE_AREA_CIRCLE: {
                r = Math.PI * (question.values[0].value * question.values[0].value);
                break;
            }
            case QuestionModel.TYPE_DIAMETER: {
                r = question.values[0].value * 2;
                break;
            }
            case QuestionModel.TYPE_RADIUS: {
                r = question.values[0].value / (Math.PI * 2);
                break;
            }
        }

        question.values.push(new QuestionValueMeasurementLabel(parseFloat(r.toFixed(1)), P3.assets.texture(randomData.texture), ''));
        question.options = this.generateOptions(question, 5);
        question.notations = randomData.notations;
        question.unit = unit;

    }

    _perimeter(data, question) {
        /*
        let getEven = (min, max) => {
            let result = min + Math.floor((max - min + 1) * Math.random());
            if (result % 2 === 0)
                return result;
            return getEven(min, max);
        };
        let unit = P3.utils.selectRandom(data.units);
        let result = getEven(data.difficulty === 0 ? 10 : 110, data.difficulty === 0 ? 25 : 200);

        //P3.math.randomInt(data.difficulty === 0 ? 10 : 110, data.difficulty === 0 ? 25 : 200);
        let val1 = P3.math.randomInt(1, (result / 2) - 4);
        let val2 = (result - (val1 * 2)) / 2;
        */

        //const val1 = P3.math.randomInt()

        //needed to ensure the two numbers were unique so redid this function - ob
        let val1, val2;

        if (data.difficulty === 0) {
            val1 = Math.round(P3.math.randomInt(2, 8) / 2) * 2;
            val2 = val1;
            while (val2 === val1) {
                val2 = Math.round(P3.math.randomInt(2, 8) / 2) * 2;
            }
        } else {
            val1 = Math.round(P3.math.randomInt(10, 20) / 2) * 2;
            val2 = val1;
            while (val2 === val1) {
                val2 = Math.round(P3.math.randomInt(10, 20) / 2) * 2;
            }
        }

        let unit = P3.utils.selectRandom(data.units);
        const result = (val1 + val2) * 2;

        question.values.push(new QuestionValueUnitConversion(val1, unit.long));
        question.values.push(new QuestionValueUnitConversion(val2, unit.long));
        question.values.push(new QuestionValueUnitConversion(result, unit.short));

        //
        // let values = this._generateValues(unit.range, data.values - 1);
        // let r = 0;
        // values.forEach((n)=> {
        // 	r += (n * 2);
        //
        // });
        question.units = unit;
        question.part = 2;
    }

    _generateValues(range, count) {
        let values = [];

        for (let i = 0; i < count; i++) {
            //check if range is float or int. if float then round to 1 decimal place
            const n = range.min % 1 === 0 ? P3.math.randomInt(range.min, range.max) : Math.round(P3.math.random(range.min, range.max) * 10) / 10;
            values.push(Math.round(n * 10) / 10);
        }
        return values;
    }

    _generateMeasurementLabel(data, unit) {
        let labels = [];
        for (let i = 0; i < data.labels.length; ++i) {
            let label = data.labels[i];
            const n = P3.math.randomInt(label.range.min, label.range.max);
            labels.push(new QuestionValueMeasurementLabel(n, '', label.value, unit.short));
        }
        return labels;
    }

    generateOptions(question, count = 5) {
        let k = 1000;
        let options = [question.answer];

        let precision = (a) => {
            if (!isFinite(a)) return 0;
            var e = 1, p = 0;
            while (Math.round(a * e) / e !== a) {
                e *= 10;
                p++;
            }
            return p;
        };

        let round = (value, decimals) => {
            return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
        };

        let answerPrecision = precision(question.answer.value);

        switch (question.type) {
            default: {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        const min = Math.min(-10, -question.answer.value);
                        const max = Math.max(10, question.answer.value);
                        return Math.abs(round(question.answer.value + P3.math.random(min, max), answerPrecision));
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValue(value));
                }
                P3.utils.shuffleArray(options);
                return options;
            }
            case QuestionModel.TYPE_AREA_PARALLELOGRAM: {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        const min = -5;
                        const max = 5;
                        return Math.abs(question.answer.value + P3.math.randomInt(min, max));
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValue(value));
                }
                P3.utils.shuffleArray(options);
                return options;
            }
            case QuestionModel.TYPE_COVERSION_X_IN_Y: {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        const min = Math.min(-10, -question.answer.value);
                        const max = Math.max(10, question.answer.value);
                        return Math.abs(round(question.answer.value + P3.math.random(min, max), answerPrecision));
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValueUnitConversion(value, question.units[question.reversed ? 1 : 0].short));
                }
                P3.utils.shuffleArray(options);
                return options;
            }
            case QuestionModel.TYPE_COVERSION_PERCENT_OF_X: {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        const min = Math.min(-10, -question.answer.value);
                        const max = Math.max(10, question.answer.value);
                        return Math.abs(round(question.answer.value + P3.math.random(min, max), answerPrecision));
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValueUnitConversion(value, question.units[0].short));
                }
                P3.utils.shuffleArray(options);
                return options;
            }
            case QuestionModel.TYPE_COVERSION_SUBTRACTION: {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        var length = Math.log(question.answer.value) * Math.LOG10E + 1 | 0;
                        const min = Math.min(-10, -question.answer.value);
                        const max = Math.max(10, question.answer.value);
                        if (length < 3) {
                            return Math.abs(round(question.answer.value + P3.math.random(min, max), answerPrecision));
                        } else
                            return Math.abs(Math.round(question.answer.value + (P3.math.random(min, max) / 100) * 100));
                        //return Math.abs(Math.round(question.answer.value + P3.math.random(min, max) * 100) / 100);
                    })();
                    let unit = question.part === 3 ? question.units[1].short : question.units[0].short;
                    options.every(x => x.value !== value) && options.push(new QuestionValueUnitConversion(value, unit));
                }
                P3.utils.shuffleArray(options);
                return options;
            }
            case QuestionModel.TYPE_COVERSION_ADDITION: {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        const min = Math.min(-10, -question.answer.value);
                        const max = Math.max(10, question.answer.value);
                        return Math.abs(round(question.answer.value + P3.math.random(min, max), answerPrecision));
                        //return Math.abs(Math.round(question.answer.value + P3.math.random(min, max) * 10) / 10);
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValueUnitConversion(value, question.units[1].short));
                }
                P3.utils.shuffleArray(options);
                return options;
            }
            case QuestionModel.TYPE_COVERSION_MULTIPLICATION: {
                while (options.length < count && k-- > 0) {
                    let conversionFactor;
                    const value = (() => {
                        conversionFactor = question.units[P3.math.randomInt(0, question.units.length - 2)];
                        const min = Math.min(-10, -question.values[0].value);
                        const max = Math.max(10, question.values[0].value);
                        return Math.abs(round(question.values[0].value + P3.math.random(min * conversionFactor.conversion, max * conversionFactor.conversion), answerPrecision));
                        //return Math.abs(Math.round((question.values[0].value + P3.math.random(min * conversionFactor.conversion, max * conversionFactor.conversion) * 10) / 10));
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValueUnitConversion(value, conversionFactor.short));
                }
                P3.utils.shuffleArray(options);
                return options;
            }
            case QuestionModel.TYPE_COVERSION_EQUIVALENT: {
                options = [];
                let usableConversion = P3.utils.copyObject(question.units);
                usableConversion.splice(usableConversion.length - 1, 1);
                while (options.length < count && k-- > 0) {
                    let conversionFactor;
                    const value = (() => {
                        conversionFactor = usableConversion[P3.math.randomInt(0, usableConversion.length - 1)];
                        const min = Math.min(-10, -question.values[0].value);
                        const max = Math.max(10, question.values[0].value);
                        return Math.abs(round(question.values[0].value + P3.math.random(min * conversionFactor.conversion, max * conversionFactor.conversion), answerPrecision));
                        //return Math.abs(Math.round((question.values[0].value + P3.math.random(min * conversionFactor.conversion, max * conversionFactor.conversion) * 10) / 10));
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValueUnitConversion(value, conversionFactor.short));
                }
                P3.utils.shuffleArray(options);
                return options;
            }
            case QuestionModel.TYPE_LIQUID_MEASUREMENT: {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        const min = Math.min(0);
                        const max = Math.max(question.values[0].value);
                        //return Math.abs(Math.round(question.answer.value + P3.math.random(min, max) * 100) / 100);
                        if (question.difficulty === 0)
                            return Math.ceil(P3.math.random(min, max) / 5) * 5;
                        return Math.abs(round(P3.math.random(min, max), answerPrecision));
                    })();
                    let unit = question.units[1].short;
                    options.every(x => x.value !== value) && options.push(new QuestionValueUnitConversion(value, unit));
                }
                P3.utils.shuffleArray(options);
                return options;
            }
        }
    }
}